// extracted by mini-css-extract-plugin
export default {"rating":"oJ-z","numberOfStars":"pJ-z","count":"qJ-z","barGraphSpacing":"rJ-z","barGraph":"sJ-z"};